import React from 'react';
import { Box, IconButton, TableCell, TableRow, Typography, useMediaQuery } from '@mui/material';
import EyeIcon from "../../common/assests/eyegreen.png";
import ReyLeaf from '../../common/assests/reyleafLogo.svg'
import configuration from '../../config/Config';

const PopularProductRow = ({ row, StarRatingComponent, handleViewMore }) => {
  const isSmallScreen = useMediaQuery("(max-width:480px)");

  return (
    <TableRow key={row?._id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
       <TableCell>
            <img
            src={
                row?.photos &&  row?.photos?.length > 0 
                ? `${configuration.cdnFront}/${ row?.photos[0].url}`
                : ReyLeaf 
            }
                alt={"Product"}
                style={{
                height: "50px",
                width: "50px",
                marginRight: "8px",
                borderRadius: "50%",
                }}
            />
    </TableCell>

      <TableCell>{row?.title || "-"}</TableCell>
      <TableCell>{row?.vendor?.fullname || "-"}</TableCell>
      <TableCell>{row?.category?.name || "-"}</TableCell>
      <TableCell>{row?.description || "-"}</TableCell>
      <TableCell >
        {StarRatingComponent ? <StarRatingComponent rating={row?.averageRating || 0} /> : "-"}
        {row?.averageRating ? row.averageRating.toFixed(2) : "0"}

      </TableCell>
      <TableCell>{`$${row?.price || "-"}`}</TableCell>

<TableCell>{`$${row?.discountedProce || "-"
  }`}</TableCell>
      <TableCell>
        <IconButton onClick={handleViewMore}>
          <img
            src={EyeIcon}
            alt="view icon"
            style={{
              height: isSmallScreen ? "35px" : "45px",
              width: isSmallScreen ? "35px" : "45px",
            }}
          />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default PopularProductRow;
